import axios from "axios";
import Swiper from "swiper";
import { getCommonVars } from './../common/common.js';
import SelfPickup from '../product/self-pickup.js';
import {Navigation, Pagination} from "swiper/modules";
import '~/swiper/swiper-bundle.min.css';


document.addEventListener('DOMContentLoaded', () => {
    const { baseUrl } = getCommonVars();
    new SelfPickup();

    const getElement = (context, selector) => {
        if (!context && !selector) {
            return null;
        }

        return context.querySelector(selector);
    };

    // banners slider
    const mainBannersSlider = document.querySelectorAll('[data-slider="main-list-banners"]');

    if (mainBannersSlider !== null) {
        mainBannersSlider.forEach((el) => {
            window.test = el;
            const swiperContainer = el.querySelector('.swiper');
            const catalogSwiper = new Swiper(el.querySelector('.swiper'), {
                modules: [Navigation, Pagination],
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                simulateTouch: true,
                lazy: {
                    loadOnTransitionStart: true,
                    loadPrevNextAmount: 2,
                    loadPrevNext: true
                },
                loop: true,
                autoplay: {
                    delay: 3000,  // Перемикання слайдів кожні 3 секунди
                    disableOnInteraction: false,  // Не зупиняти autoplay після взаємодії з слайдером
                },
                followFinger: true,
                on: {
                    afterInit: (swiper) => {
                        updateBullets(swiper);
                    },
                    slideChange: (swiper) => {
                        updateBullets(swiper);
                    },
                    reachEnd: () => {
                        el.classList.add('is-end');
                    },
                    fromEdge: () => {
                        el.classList.remove('is-end');
                    }
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true,
                    renderBullet: (index, className) => {
                        return `<span class="${className}" data-index="${index}"></span>`;
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.js-next-swiper'), // Кнопка "Наступний"
                    prevEl: el.querySelector('.js-prev-swiper'), // Кнопка "Попередній"
                    disabledClass: 'swiper-lock'
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 8
                    },
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        spaceBetween: 8
                    },
                    1024: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 16
                    },
                },
            });

            function updateBullets(swiper) {
                const bullets = swiper.pagination?.el?.querySelectorAll('.swiper-pagination-bullet');
                if (!bullets?.length) return;

                const active = swiper.activeIndex;
                const lastIndex = swiper.slides.length - 1;

                bullets.forEach((bullet, index) => {
                    bullet.style.transition = 'width 0.1s linear, height 0.1s linear';

                    const activeSize = '8px';
                    const neighborSize = '6px';
                    const defaultSize = '4px';

                    if (index === active) {
                        bullet.style.width = activeSize;
                        bullet.style.height = activeSize;
                    } else if (index === active - 1 || index === active + 1) {
                        bullet.style.width = neighborSize;
                        bullet.style.height = neighborSize;
                    } else {
                        bullet.style.width = defaultSize;
                        bullet.style.height = defaultSize;
                    }
                });

                swiper.pagination.el.scrollLeft =
                    bullets[swiper.activeIndex].offsetLeft - swiper.pagination.el.offsetWidth / 2 + bullets[swiper.activeIndex].offsetWidth / 2;
            }

            window.addEventListener('resize', () => {
                updateBullets(catalogSwiper);
            });

            updateBullets(catalogSwiper);
        });
    }



    const sliders = document.querySelectorAll('.js-filter-slider');

    if (sliders.length) {
        sliders.forEach((slider) => {
            const loader = slider.querySelector('.js-loader-block');
            const displayLoader = () => {
                if (loader) {
                    loader.classList.add('show');
                }
            }
            const hideLoader = () => {
                if (loader) {
                    loader.classList.remove('show');
                }
            }

            const filterItems = slider.querySelectorAll('.js-filter-slides');
            const swiperWrapper = slider.querySelector('.swiper-wrapper');
			let swiperInstance = slider.querySelector('.swiper')?.swiper;

            // Локальний стек завантажених категорій
            const loadedSlideIds = new Set();
            const loadingStates = new Map(); // Заблокувати повторне натискання під час запиту

            const filterSlides = async (activeId) => {
                if (loadingStates.get(activeId)) return;
                const alreadyLoaded = loadedSlideIds.has(activeId);
                if (!alreadyLoaded) {
                    try {
                        await displayLoader();
                        await loadingStates.set(activeId, true);
                        const catId = activeId.replace('slides-', '');
                        const response = await axios.post(baseUrl + '/loadbestprods', { id: catId });

                        if (response.data?.html) {
                            // Вставити слайди
                            await swiperWrapper.insertAdjacentHTML('beforeend', response.data.html);
                            await loadedSlideIds.add(activeId);
                        }
                    } catch (e) {
                        console.error('Помилка при завантаженні слайдів:', e);
                    } finally {
                        await loadingStates.set(activeId, false);
                        await hideLoader();
                    }
                }

                // Показати тільки потрібні слайди
                await swiperWrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
                    slide.style.display = slide.getAttribute('data-id') === activeId ? '' : 'none';
                });
				swiperInstance = slider.querySelector('.swiper')?.swiper;
                setTimeout(() => {
					if (!swiperInstance) {
						console.error('Swiper instance not found');
					}
                    swiperInstance?.update();
                    swiperInstance?.slideTo(0);
                }, 300);
            };
            // Додаємо вже присутній слайд
            const initialActiveFilter = slider.querySelector('.js-filter-slides.is-active');
            if (initialActiveFilter) {
                loadedSlideIds.add(initialActiveFilter.getAttribute('data-id'));
            }
            filterItems.forEach(async (filter) => {
                await filter.addEventListener('click', async () => {
                    const activeId = filter.getAttribute('data-id');
                    // Не змінюємо is-active до завершення завантаження слайдів
                    filterSlides(activeId).then(()=> {
                        if (filter.classList.contains('is-active')) return;
                        slider.querySelector('.js-filter-slides.is-active')?.classList.remove('is-active');
                        filter.classList.add('is-active');
                    });
                });
            });
        });
    }
});
